import React, { useState } from 'react';
import { isMobile, isTablet } from '../../../shared/utils/deviceUtils';

export const Newsletter: React.FC = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const mobile = isMobile();
  const tablet = isTablet();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email) return;
    setLoading(true);
    // TODO: Implement actual newsletter subscription logic
    // Simulate async request
    setTimeout(() => {
      setLoading(false);
      setSuccess(true);
    }, 1200);
  };

  return (
    <section
      className={`${mobile ? 'my-12' : tablet ? 'my-16' : 'my-16 md:my-20'} py-8 bg-gradient-to-r from-primary-500 to-primary-600`}
    >
      <div className="max-w-xl w-full mx-auto px-4 sm:px-6 lg:px-8 p-4 sm:p-6 lg:p-8 flex flex-col items-center">
        <h3
          className={`${mobile ? 'text-xl' : tablet ? 'text-2xl' : 'text-2xl md:text-3xl'} font-bold text-white text-center mb-2`}
        >
          Ready for Your Next Adventure?
        </h3>
        <p
          className={`${mobile ? 'text-sm' : 'text-base md:text-lg'} text-white/90 text-center mb-4 max-w-2xl`}
        >
          Subscribe for exclusive offers & tips
        </p>
        {success ? (
          <div className="flex flex-col items-center w-full animate-fade-in">
            <div className="mb-2">
              <svg
                className={`${mobile ? 'w-10 h-10' : 'w-12 h-12'} text-green-300 animate-bounce-in`}
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <circle
                  cx="12"
                  cy="12"
                  r="11"
                  stroke="currentColor"
                  strokeWidth="2"
                  fill="none"
                />
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M7 13l3 3 6-6"
                />
              </svg>
            </div>
            <p
              className={`${mobile ? 'text-base' : 'text-lg'} text-white font-semibold mb-1`}
            >
              Subscribed!
            </p>
            <p className={`${mobile ? 'text-xs' : 'text-sm'} text-white/80`}>
              Thank you for joining our newsletter.
            </p>
          </div>
        ) : (
          <form
            className={`w-full flex ${mobile ? 'flex-col' : 'flex-col sm:flex-row'} items-center justify-center gap-3 mb-2 p-4 sm:p-6 lg:p-8`}
            onSubmit={handleSubmit}
          >
            <input
              type="email"
              placeholder="Your email address"
              value={email}
              onChange={e => setEmail(e.target.value)}
              disabled={loading}
              className={`flex-1 px-4 py-2 rounded-xl border border-white/30 bg-white/10 text-white placeholder-white/70 ${mobile ? 'min-w-full' : 'min-w-[160px] md:min-w-[220px]'} focus:outline-none focus:ring-2 focus:ring-white/30 disabled:opacity-60`}
              required
            />
            <button
              type="submit"
              disabled={loading}
              className={`${mobile ? 'w-full px-5 py-2 text-sm' : 'px-5 py-2'} bg-white text-primary-600 rounded-xl font-medium hover:bg-neutral-100 transition-colors whitespace-nowrap ${mobile ? 'mt-2' : 'mt-2 sm:mt-0'} disabled:opacity-60 flex items-center justify-center`}
            >
              {loading ? (
                <svg
                  className={`${mobile ? 'w-4 h-4' : 'w-5 h-5'} animate-spin mr-2`}
                  fill="none"
                  viewBox="0 0 24 24"
                >
                  <circle
                    className="opacity-25"
                    cx="12"
                    cy="12"
                    r="10"
                    stroke="currentColor"
                    strokeWidth="4"
                  ></circle>
                  <path
                    className="opacity-75"
                    fill="currentColor"
                    d="M4 12a8 8 0 018-8v8z"
                  ></path>
                </svg>
              ) : null}
              {loading ? 'Subscribing...' : 'Subscribe'}
            </button>
          </form>
        )}
        <p
          className={`${mobile ? 'text-xs' : 'text-xs'} text-white/70 mt-2 text-center`}
        >
          No spam, unsubscribe at any time
        </p>
        <style>{`
          .animate-fade-in { animation: fadeIn 0.7s; }
          @keyframes fadeIn { from { opacity: 0; transform: translateY(16px);} to { opacity: 1; transform: none; } }
          .animate-bounce-in { animation: bounceIn 0.7s cubic-bezier(.68,-0.55,.27,1.55); }
          @keyframes bounceIn { 0% { opacity: 0; transform: scale(0.7);} 60% { opacity: 1; transform: scale(1.1);} 100% { transform: scale(1); } }
        `}</style>
      </div>
    </section>
  );
};
